import Alpine from 'alpinejs';
import axios from '../../config/axios.js';
import { isPanelOrCustomerAuth, isPanelPath } from '../../utils/sessionCleanup.js';

const toast = (msg, type = 'info') => window.toast?.(msg, type);
const money = (n) =>
  window.formatRupiah ? window.formatRupiah(n) : `Rp ${Number(n || 0).toLocaleString('id-ID')}`;

Alpine.data('surangMarketplace', () => ({
  loading: true,
  items: [],
  categories: [],
  q: '',
  source: '',
  categoryId: '',
  sort: 'popular',

  async init() {
    await Promise.all([this.loadCategories(), this.fetch()]);
  },

  async loadCategories() {
    try {
      const { data } = await axios.get('/api/v1/surang/marketplace/categories');
      this.categories = data.data || [];
    } catch (_) {
      this.categories = [];
    }
  },

  async fetch() {
    this.loading = true;
    try {
      const { data } = await axios.get('/api/v1/surang/marketplace', {
        params: {
          q: this.q || undefined,
          source: this.source || undefined,
          category_id: this.categoryId || undefined,
          sort: this.sort,
          per_page: 24,
        },
      });
      this.items = data.data || [];
    } catch (e) {
      toast('Gagal memuat marketplace.', 'error');
    } finally {
      this.loading = false;
    }
  },

  async toggleFav(t) {
    if (!isPanelOrCustomerAuth()) {
      window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname);
      return;
    }
    try {
      const { data } = await axios.post(`/api/v1/surang/marketplace/${t.id}/favorite`);
      t.is_favorite = data.data?.is_favorite;
    } catch (e) {
      toast(e?.response?.data?.message || 'Gagal favorit.', 'error');
    }
  },

  useTemplate(t) {
    const productId = t.product?.id;
    if (productId) {
      window.location.href = `/surang/start/${productId}?template_id=${t.id}`;
      return;
    }
    window.location.href = '/surang';
  },
}));

Alpine.data('surangCreatorHub', () => ({
  loading: true,
  busy: false,
  data: null,
  elementCategories: [
    'shapes', 'graphics', '3d', 'animation', 'photos', 'frames', 'grids',
    'videos', 'audio', 'forms', 'mockups', 'charts', 'sheets', 'tables',
  ],
  uploadElement: { name: '', category: 'shapes', access: 'free', file: null },
  uploadFont: { name: '', family: '', access: 'free', file: null },
  withdraw: { amount: '', bank_name: '', account_name: '', account_number: '' },
  money,

  async init() {
    if (!isPanelOrCustomerAuth()) {
      this.loading = false;
      return;
    }
    try {
      await axios.put('/api/v1/surang/creator/profile', {});
      const { data } = await axios.get('/api/v1/surang/creator/revenue');
      this.data = data.data;
    } catch (e) {
      toast('Gagal memuat creator hub.', 'error');
    } finally {
      this.loading = false;
    }
  },

  async submitWithdraw() {
    this.busy = true;
    try {
      await axios.post('/api/v1/surang/creator/withdrawals', {
        amount: Number(this.withdraw.amount),
        method: 'bank',
        destination: {
          bank_name: this.withdraw.bank_name,
          account_name: this.withdraw.account_name,
          account_number: this.withdraw.account_number,
        },
      });
      toast('Permintaan penarikan dikirim.', 'success');
      const { data } = await axios.get('/api/v1/surang/creator/revenue');
      this.data = data.data;
    } catch (e) {
      toast(e?.response?.data?.message || 'Gagal mengajukan.', 'error');
    } finally {
      this.busy = false;
    }
  },

  async submitElement() {
    if (!this.uploadElement.file || !this.uploadElement.name) {
      toast('Nama dan file elemen wajib.', 'error');
      return;
    }
    this.busy = true;
    try {
      const fd = new FormData();
      fd.append('name', this.uploadElement.name);
      fd.append('category', this.uploadElement.category);
      fd.append('access', this.uploadElement.access);
      fd.append('file', this.uploadElement.file);
      await axios.post('/api/v1/surang/creator/elements', fd);
      toast('Elemen creator diunggah.', 'success');
      this.uploadElement = { name: '', category: 'shapes', access: 'free', file: null };
    } catch (e) {
      toast(e?.response?.data?.message || 'Gagal upload elemen.', 'error');
    } finally {
      this.busy = false;
    }
  },

  async submitFont() {
    if (!this.uploadFont.file || !this.uploadFont.name || !this.uploadFont.family) {
      toast('Nama, family, dan file font wajib.', 'error');
      return;
    }
    this.busy = true;
    try {
      const fd = new FormData();
      fd.append('name', this.uploadFont.name);
      fd.append('family', this.uploadFont.family);
      fd.append('access', this.uploadFont.access);
      fd.append('file', this.uploadFont.file);
      await axios.post('/api/v1/surang/creator/fonts', fd);
      toast('Font creator diunggah.', 'success');
      this.uploadFont = { name: '', family: '', access: 'free', file: null };
    } catch (e) {
      toast(e?.response?.data?.message || 'Gagal upload font.', 'error');
    } finally {
      this.busy = false;
    }
  },
}));
